import { CancelReversalMutation } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

// 解約を行う
export const cancelReversalMutationHandler =
  graphql.mutation<CancelReversalMutation>(
    "cancelReversal",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          cancelReversal: {
            result: true,
          },
        },
      });
    }
  );
